import api, { apiSetup } from '../api';

apiSetup();

export class ThemesService {
  BASE_URL = '/themes';

  get() {
    return api.get(this.BASE_URL);
  }
}
